/* unplugin-vue-components disabled */import { render } from "./Default.vue?vue&type=template&id=f513a7ee"
const script = {}

import "./Default.vue?vue&type=style&index=0&id=f513a7ee&lang=scss"

import exportComponent from "../../../../common/temp/node_modules/.pnpm/vue-loader@17.2.2_3tnefydtqxjg44ddub7xm4i2wi/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__